import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';
import environment from 'scaleflow/config/environment';

class LogoutRoute extends Route {
  @service session;
  @service router;
  @service tracker;

  async beforeModel() {
    const logoutUrl = this.logoutURL();
    await this.session.invalidate();
    await this.tracker.trackLogout();
    window.location.href = logoutUrl;
    // this.router.transitionTo('login');
  }

  logoutURL() {
    return `${environment.cognito.domain}/logout?client_id=${environment.cognito.clientId}&response_type=code&scope=aws.cognito.signin.user.admin+email+openid&logout_uri=${window.location.origin}/login`;
  }
}

export default instrumentRoutePerformance(LogoutRoute);
